/** French plural: 0 and 1 are singular */
const s = (count: number) => (count > 1 ? 's' : '');

const en = {
  /** Deletes the item, in its side panel */
  remove: 'Remove',
  title: 'Shows',
  importJson: 'Import JSON',
  add: 'Add show',
  clearAll: 'Clear all shows',
  search: 'Search shows...',
  allStages: 'All stages',
  nights: 'Nights',
  /** A night's number of shows, in its tab */
  count: (count: number) => `${count} ${count === 1 ? 'show' : 'shows'}`,
  list: 'List',
  timeline: 'Timeline',
  timelineNote: 'Each night runs from noon to noon, in your time zone.',
  artist: 'Artist',
  stage: 'Stage',
  when: 'When',
  featured: 'Team recommendation',
  addFeatured: 'Add to team recommendations',
  removeFeatured: 'Remove from team recommendations',
  featuredHelp: 'Feature this show in the homepage recommendations when the homepage is enabled.',
  unknownArtist: 'Unknown artist',
  unknownStage: 'Unknown stage',
  missingArtistOrStage: 'Missing artist or stage',
  empty: 'No shows yet. Add one, or import a JSON file.',
  noMatch: 'No show matches this search.',
  edit: 'Edit show',
  selectArtist: 'Select an artist',
  selectStage: 'Select a stage',
  /** The time fields read "Starts [date] at [time]", "Ends [date] at [time]" */
  starts: 'Starts',
  ends: 'Ends',
  at: 'at',
  startDate: 'Start date',
  startTime: 'Start time',
  endDate: 'End date',
  endTime: 'End time',
  /** After the show's duration */
  endsAfterMidnight: 'ends after midnight',
  startAfterEnd: 'Show start time must be before end time',
  deleteConfirm: 'Are you sure you want to delete this show?',
  deleteTitle: 'Delete show',
  invalidJson: 'Invalid JSON format. The file must contain a "shows" array.',
  noneValid: 'No valid shows found in the file.',
  /** Which imported show an error is about */
  importedShow: (artist?: string, scene?: string) => `[${artist || 'Unknown Artist'} at ${scene || 'Unknown Scene'}]`,
  /** `refused` shows had the `errors`: a show can have several */
  importReport: (imported: number, refused: number, errors: string[]) =>
    `Successfully imported ${imported} shows.${refused > 0 ? `\n\n${refused} shows were not imported due to errors:\n${errors.join('\n')}` : ''}`,
  clearAllTitle: 'Clear All Shows',
  clearAllConfirm: (count: number) => `Are you sure you want to delete all ${count} shows? This action cannot be undone.`,
  clearAllButton: 'Clear All',
};

const fr: typeof en = {
  remove: 'Supprimer',
  title: 'Shows',
  importJson: 'Importer un JSON',
  add: 'Ajouter un show',
  clearAll: 'Effacer tous les shows',
  search: 'Rechercher des shows...',
  allStages: 'Toutes les scènes',
  nights: 'Nuits',
  count: count => `${count} show${s(count)}`,
  list: 'Liste',
  timeline: 'Planning',
  timelineNote: 'Chaque nuit va de midi à midi le lendemain, dans votre fuseau horaire.',
  artist: 'Artiste',
  stage: 'Scène',
  when: 'Horaire',
  featured: 'Reco de la team',
  addFeatured: 'Ajouter aux recos de la team',
  removeFeatured: 'Retirer des recos de la team',
  featuredHelp: 'Affiche ce show dans les recommandations de l’accueil lorsque celui-ci est activé.',
  unknownArtist: 'Artiste inconnu',
  unknownStage: 'Scène inconnue',
  missingArtistOrStage: 'Il manque l\'artiste ou la scène',
  empty: 'Aucun show pour l\'instant. Ajoutez-en un, ou importez un fichier JSON.',
  noMatch: 'Aucun show ne correspond à cette recherche.',
  edit: 'Modifier le show',
  selectArtist: 'Choisir un artiste',
  selectStage: 'Choisir une scène',
  starts: 'Commence le',
  ends: 'Se termine le',
  at: 'à',
  startDate: 'Date de début',
  startTime: 'Heure de début',
  endDate: 'Date de fin',
  endTime: 'Heure de fin',
  endsAfterMidnight: 'se termine après minuit',
  startAfterEnd: 'Le show doit commencer avant de se terminer',
  deleteConfirm: 'Voulez-vous vraiment supprimer ce show\u00a0?',
  deleteTitle: 'Supprimer le show',
  invalidJson: 'Format JSON invalide. Le fichier doit contenir un tableau «\u00a0shows\u00a0».',
  noneValid: 'Aucun show valide dans le fichier.',
  importedShow: (artist, scene) => `[${artist || 'Artiste inconnu'} sur ${scene || 'Scène inconnue'}]`,
  importReport: (imported, refused, errors) =>
    `${imported} show${s(imported)} importé${s(imported)}.${refused > 0 ? `\n\n${refused} show${s(refused)} non importé${s(refused)} à cause d'erreurs\u00a0:\n${errors.join('\n')}` : ''}`,
  clearAllTitle: 'Effacer tous les shows',
  clearAllConfirm: count =>
    `Voulez-vous vraiment supprimer ${count > 1 ? `les ${count} shows` : `${count} show`}\u00a0? Cette action est irréversible.`,
  clearAllButton: 'Tout effacer',
};

const messages = { en, fr };
export default messages;
